import {CONST}   from '../../config'
import {copyArr} from '../../util';
/*************************************************************
 * RowActMixin
 *     행의 동작과 관련된 행위를 처리하는 Mixin 입니다.
 *      ex) 행선택, 행 수정/삭제 등
 *************************************************************/
export default {
    data() {return {
        //-----------------------------------------------
        // Selection
        mx_focused      : null,
        vars_lastSelRow : null,
        //-----------------------------------------------
        // Row edit
        vars_currEditRow  : null,
        vars_onCreating   : false,
    }},
    methods: {
        //-----------------------------------------------
        // Selection
        //-----------------------------------------------
        // [METHOD] Selection : set Select : set selected row
        mx_setSelect(row, isMulti) {
            let _flag = isMulti!==undefined ? isMulti : this.mx_options.multiSelect;
            this.vars_lastSelRow = row;
            this.mx_dataSet.setSelect(row, _flag);
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : set Select - range : set range selected row
        mx_setRangeSelect(row, appendFlag) {
            this.mx_dataSet.setSelectRange(this.vars_lastSelRow, row, appendFlag);
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : select all
        mx_selectAll() {
            this.mx_dataSet.setSelectAll();
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : deselect all
        mx_resetSelect() {
            this.mx_dataSet.setDeselectAll();
            this.mx_fireEvent('selected',this.mx_getSelected())
        },
        // [METHOD] Selection : get Select : return selected row
        mx_getSelected() {
            var sel = this.mx_dataSet.getSelected();
            if(this.mx_options.multiSelect) {
                return sel;
            } else {
                return sel.length?sel[0]:undefined;
            }
        },
        // [METHOD] Selection : set focus.
        mx_setFocus(r) {
            if(this.mx_options.cellMode) return;
            var beforeFlag = !!r ? r.__focused : null;
            // 1. Un-focus previous
            if(this.mx_focused) {
                this.mx_setValue(this.mx_focused, '__focused', false)
                this.mx_focused = null;
            }
            // 2. Do toggle!
            if(!!r && !beforeFlag) {
                this.mx_setValue(r, '__focused', true)
                this.mx_focused = r;
            }
        },
        // [METHOD] Selection : reset focus.
        mx_resetFocus() {
            this.mx_setFocus();
        },
        //-----------------------------------------------
        // Row edit
        //-----------------------------------------------
        // [METHOD] Row edit : Toggle row editable.
        mx_toggleRowModify(row) {
            this.vars_onCreating = false; 
            // 1. unSet previous
            if(this.vars_currEditRow) {
                this.mx_setValue(this.vars_currEditRow, '__editMode', false)
            }
            // 2. set row-self
            var next = this.mx_dataSet.getRow(row.__id); // next === row?
            next.__editMode = true;
            this.mx_dataSet.emitUpdate(next);
            // 3. set to global var : currEditRow === clone of row
            var modif = Object.assign({}, next);
            this.vars_currEditRow = modif; // isReactive?
            // x. fire event to page
            this.mx_fireEvent('begin-edit', modif);
            this.mx_fireEvent('btn-modify', modif);
        },
        // [METHOD] Row edit : Validate row.
        mx_checkRowValid(row) {
            var rtn = true;
            this.mx_fieldsInfo.forEach(f => {
                if(f.readonly) {return}
                if(row.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE && !f.edit) {return}
                if(!f.__rules) {return}
                var v = row[f.value];
                rtn = !f.__rules.find(rule => {
                    var txt = rule(v,row,this.mx_caller);
                    if(txt === true) return false;
                    rtn = false;
                    this.mx_addCellMsg(txt, row, f);
                    return true;
                }) && rtn;
                if(rtn) {this.mx_delCellMsg(row, f)}
            });
            return rtn;
        },
        // [METHOD] Row edit : Row save
        mx_toggleRowSaved(row) {
            // 0. prepare save
            // 0.1 check on editing? or not.
            if(!row) return;
            // 0.2 validation
            if(!this.mx_options.manualValid && !this.mx_checkRowValid(row)){
                return;
            }
            // 1. save!
            // 1.1. set flag before save
            row.__editMode = false;
            // 1.2 convert data
            this.mx_fieldsInfo.forEach(f => {
                if(!f.edit) {return}
                if(f.saveConverter) {
                    row[f.value] = f.saveConverter(row[f.value], row, f);
                }
            });
            // 1.3 copy to origin
            this.mx_dataSet.setRow(row.__id, row);
            // 2. unflaged
            this.vars_currEditRow = null;
            // x. fire event to page
            this.mx_fireEvent('end-edit');
            this.mx_fireEvent('btn-save', row);
            this.mx_fireEvent('data-changed',this.mx_getChanged());
        },
        // [METHOD] Row edit : Cancel updating
        mx_toggleEditCancel() {
            if(!this.vars_currEditRow) return;
            // 2. reset edited
            var row = this.mx_dataSet.getRow(this.vars_currEditRow.__id);
            if(this.vars_onCreating) {
                this.mx_dataSet.removeTempRow();
            } else {
                row.__editMode = false;
                this.mx_dataSet.emitUpdate(row);
            }
            // 3. remove validation
            this.mx_delCellMsg(row)
            this.vars_currEditRow = null;
            // x. fire event.
            this.mx_fireEvent('end-edit');
            this.mx_fireEvent('btn-cancel');
        },
        // [METHOD] Row edit : Remove rows
        mx_removeRows(rows) {
            const selCnt = this.getSelected().length;
            rows.forEach(r => this.mx_delCellMsg(r));
            if(rows.length===1 && !this.mx_options.blockAutoSelectOnDelete) {
                this.mx_dataSet.removeRow(rows[0],true)
            } else {
                this.mx_dataSet.removeRows(rows)
                this.mx_dataSet.setDeselectAll()
            }
            // x. fire event(send data before reset)
            this.mx_fireEvent('btn-delete', rows, selCnt)
        },
        // [METHOD] Row edit : Create empty(new) row & save
        mx_createEmptyRow(idx) {
            // WARNING : idx 유무가 꼭 이벤트 발동을 결정하는건 아닐꺼 같기는 한데..
            var addOnly = !!idx;
            // 0. Prepare
            var emptyRow = Object.assign({},this.mx_setHeaders_makeDefaultObj());
            emptyRow.__dirty = CONST.VAL.DIRTY.FLAG.CREATE;
            // 1. Append field
            this.mx_fieldsInfo.forEach(f => {
                emptyRow[f.value] = emptyRow[f.value]||undefined;
            })
            // 2. Add row
            const IDX = idx || 0;
            this.mx_dataSet.addRow(emptyRow, IDX); // append to first
            // 3. Set focus if cellEdit
            if(this.mx_options.cellEdit && !addOnly) {
                this.mx_focusFirstCell(IDX);
            }
            
            // x. fire event(send data before reset)
            if(!addOnly) {this.mx_fireEvent('btn-add');}
            // $emit.'data-changed' -> urDataGridMixin : watch.dataset.updated
        },
        // [METHOD] Row edit : Add empty(temporary) row to create new item
        mx_addEmptyRow() {
            var emptyRow = Object.assign({},this.mx_setHeaders_makeDefaultObj());
            emptyRow.__dirty = CONST.VAL.DIRTY.FLAG.CREATE;
            // 1. append field
            this.mx_fieldsInfo.forEach(f => {
                emptyRow[f.value] = emptyRow[f.value]||undefined;
            })
            // 2. add tempRow additional fields..
            let idx  = this.mx_dataSet.addTempRow(emptyRow, null); // 임시 idx -1
            var nRow = this.mx_dataSet.getViewData()[idx];
            //nRow.__selected = true;
            nRow.__editMode = true;
            // 3. make cloned row
            this.$set(this, 'vars_currEditRow', nRow)
            //this.vars_currEditRow = nRow; // need copy?
            this.vars_onCreating = true;
            // 4. Scroll to Top
            this.mx_eventBus.$emit('set-scroll-top',0)
            // x. remove all message
            this.mx_delCellMsg();
            // x. fire event.
            this.mx_fireEvent('begin-edit');
            this.mx_fireEvent('btn-add');
        },
        // [METHOD] Row edit : Create new row.
        mx_createNewRow() {
            // 0. do something..
            // 0.1 get currEditRow
            var newData = this.vars_currEditRow;
            // 0.2 validation
            if(!this.mx_options.manualValid && !this.mx_checkRowValid(newData)) {
                return;
            }
            // 1. get Data
            // 1.2 set flag
            newData.__editMode = false;
            newData.__selected = false;
            // 2. add row
            // 2.1 convert data
            this.mx_fieldsInfo.forEach(f => {
                if(!f.readonly) {return}
                if(f.saveConverter) {
                    newData[f.value] = f.saveConverter(newData[f.value], newData, f);
                }
            });
            // 2.2 ADD row
            this.mx_dataSet.addRow(newData, 0); // append to first
            // 2.3 unflaged!
            this.vars_currEditRow = null;
            // x. fire event
            this.mx_fireEvent('end-edit');
            this.mx_fireEvent('btn-save',newData);
        },
        // [METHOD] Row edit : Get dirty array
        mx_getChanged() {
            var chs = this.mx_dataSet.getChanged();
            const rtn = {
                created:copyArr(chs.created),
                updated:copyArr(chs.updated),
                removed:copyArr(chs.removed)};
            rtn.created.forEach(f=>{f.__compo = undefined})
            rtn.updated.forEach(f=>{f.__compo = undefined})
            rtn.removed.forEach(f=>{f.__compo = undefined})
            return rtn;
        },
        // [METHOD] Row Edit : is Changed or not.
        mx_isChanged() {
            const chs = this.mx_dataSet.getChanged();
            var res = 0;
            res += chs.created?chs.created.length:0;
            res += chs.updated?chs.updated.length:0;
            res += chs.removed?chs.removed.length:0;
            return res;
        },
        // [METHOD] Row Edit : is Changed or not.
        mx_validChanged() {
            const chs = this.mx_dataSet.getChanged();
            var res = true;
            if(chs.created) {
                res = chs.created.reduce((acc, row)=>{
                    return this.mx_checkRowValid(row) && acc; 
                }, res)
            }
            if(chs.updated) {
                res = chs.updated.reduce((acc, row)=>{
                    return this.mx_checkRowValid(row) && acc;
                }, res)
            }
            // [IOPS] valid onCreating row
            if(!!this.vars_currEditRow) {
                const editRow = this.vars_currEditRow;
                var flag = this.mx_checkRowValid(editRow)
                res = res && flag;
            }
            return res;
        },
    }
}